// extracted by mini-css-extract-plugin
module.exports =  {"root":"k1TnlIwd79AfGkJneYQ6","imgPreview":"Oy2oeXQqqQLYhNYRJH9l","vidPreview":"jdzpjACDy3Qo_dMY6fbT","vidPreviewClickZone":"uoa5Sgx4KEWF8XM0csXg"};